module.exports = __webpack_public_path__ + "static/lhs-video-e468884d96a52ec230aec800c77c48a8.mp4";